import { inject, provideAppInitializer } from '@angular/core';
import { UserService } from '../user/user.service';
import { of, switchMap, tap } from 'rxjs';
import { CFCacheService } from '../cache/cf-cache.service';
import { EnvironmentService } from '../environment.service';
import { BrandConfigService } from './brand-config.service';
import { StagDetectorService } from '../stag-detector.service';

export const provideBrandConfig = () => {
  return [
    provideAppInitializer(() => {
      const user = inject(UserService);
      const stag = inject(StagDetectorService);
      const cf = inject(CFCacheService);
      const env = inject(EnvironmentService);
      const brandConfig = inject(BrandConfigService);

      stag.detectStag();
      return user.getUserInfo().pipe(
        switchMap((e: any) => e?.data?.result?.info?.loggedIn ? user.getUserAccountsAndWallets(true) : of(false)),
        switchMap(() => cf.loadCfCache()),
        switchMap(() => env.loadEnvironment()),
        tap(() => {
          brandConfig.brandConfigResolved.set(true);
          brandConfig.brandConfigResolved$.next(true);
        }),
      );
    }),
  ];
}
